import { render } from "./EditSphere.vue?vue&type=template&id=0c209419&scoped=true"
import script from "./EditSphere.vue?vue&type=script&lang=js"
export * from "./EditSphere.vue?vue&type=script&lang=js"

import "./EditSphere.vue?vue&type=style&index=0&id=0c209419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c209419"]])

export default __exports__